<script setup>
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3"
import EditableNodeWrapper from "@/Components/Inputs/BlockEditor/Extension/Components/EditableNodeWrapper.vue"
import Grid from "@/Components/Inputs/BlockEditor/Extension/Components/Grid.vue"
import useNodeProps from "@/Composables/useNodeProps.js"
import EditGrid from "@/Components/Inputs/BlockEditor/Extension/Modals/EditGrid.vue"
import { computed } from "vue"
import EditStats from "@/Components/Inputs/BlockEditor/Extension/Modals/EditStats.vue"
import BaseStat from "@/Components/Inputs/BlockEditor/Extension/Components/Stats/BaseStat.vue"

const props = defineProps({
  ...nodeViewProps,
})

const {
  stats,
  cols,
  spacing
} = useNodeProps(props)

const options = computed(() => {
  return props.extension.options
})

const statsAsArray = computed(() => {
  if (Array.isArray(stats.value)) {
    return stats.value
  }

  return stats.value.split(',')
})

const getStatValue = (id) => {
  if (options.value.data.hasOwnProperty(props.node.attrs.id)) {
    return options.value.data[props.node.attrs.id].stats[id]['value']
  }

  return options.value.currentStats[id]['value']
}

const displayStats = computed(() => {
  return options.value.statOptions.filter((option) => {
    return statsAsArray.value.includes(option.id)
  }).map(stat => {
    return {
      label: stat.label,
      value: getStatValue(stat.id),
    }
  })
})
</script>

<template>
<node-view-wrapper>
  <EditableNodeWrapper v-bind="props">
    <template #tools>
      <EditGrid
        v-model:spacing="spacing"
        v-model:cols="cols"
      />
      <EditStats
        :options="options.statOptions"
        v-model:stats="stats"
      />
    </template>
    <template #content>
      <div class="text-center text-gray-400 text-sm w-full p-4" v-if="stats.length === 0">
        {{ __('No stats selected.') }}
      </div>
      <Grid v-else :cols="cols" :spacing="spacing">
        <BaseStat
          v-for="stat in displayStats"
          :key="stat.label"
          :label="stat.label"
          :value="stat.value"
        />
      </Grid>
    </template>
  </EditableNodeWrapper>
</node-view-wrapper>
</template>

